import { Component, Inject, Input, OnDestroy, OnInit } from "@angular/core";
import { Property } from "@app/models/Property";
import { Content } from "@app/models/Content";
import { ContentApi } from "@app/services/apiServices/ContentApi";
import { PmcDataService } from "@app/services/pmc-data.service";
import { take } from "rxjs/operators";
import { Subscription } from "rxjs";

@Component({
    selector: 'app-pmc-logo',
    template: `
        <div *ngIf="pmcLogo" class="pmc-logo">
            <img id="pmcLogo" [src]="pmcLogo.msg" [alt]="pmcName + 'Logo'">
        </div>
    `
})
export class PmcLogoComponent implements OnInit, OnDestroy {

    @Input() property: Property;
    @Input() pmcCoupon: string;
    pmcLogo: Content;
    pmcName = 'PMC Logo';

    private dataChangeSubscription: Subscription;

    constructor(@Inject(ContentApi) private contentApi: ContentApi,
                @Inject(PmcDataService) private pmcDataService: PmcDataService) {}

    ngOnInit(): void {
        this.activate();

        this.dataChangeSubscription = this.pmcDataService.dataChange.subscribe(resp => {
            if(resp.property === 'PmcCoupon' && resp.newValue !== undefined && resp.oldValue !== resp.newValue) {
                this.onChange();
            }
        })
    }

    activate() {
        if (!this.property && this.pmcCoupon) {
            this.contentApi.fetchCurrentLogoForPmc(this.pmcCoupon)
                .pipe(take(1)).subscribe(logo => {
                    this.pmcLogo = logo;
                });
        }
        if (this.property && this.property.pmcLogo === undefined) {
            this.pmcCoupon = this.property.hoa.pmc.couponId;
            this.pmcName = this.property.hoa.pmc.name;
            this.contentApi.fetchCurrentLogoForPmc(this.pmcCoupon)
                .pipe(take(1)).subscribe(logo => {
                    this.pmcLogo = logo;
                    this.property.pmcLogo = logo;
                });
        }
        if (this.property.pmcLogo && this.pmcLogo === undefined) {
            this.pmcLogo = this.property.pmcLogo;
            this.pmcCoupon = this.property.hoa.pmc.couponId;
            this.pmcName = this.property.hoa.pmc.name;
        }
    }

    onChange(){
        this.pmcCoupon = this.pmcDataService.getPmcCoupon();
        this.pmcName = this.pmcDataService.getPmcName();
        if (this.pmcCoupon) {
            this.contentApi.fetchCurrentLogoForPmc(this.pmcCoupon)
                .pipe(take(1)).subscribe(logo => {
                    this.pmcLogo = logo;
                    if (this.property) {
                        this.property.pmcLogo = logo;
                    }
                });
        }
    }

    ngOnDestroy(): void {
        this.dataChangeSubscription.unsubscribe();
    }
}

